export default __webpack_public_path__ + "static/media/gatewayar.66b76762.png";